import React from "react";
import ContactInfo from "components/link-types/contact";

const Newsletter = ({ contact }) => (
    <div className="w-full max-w-xs mx-auto py-4 lg:py-0">
        <div className="text-xs lg:text-sm leading-5">
            <iframe src="https://my.sealskincovers.com/newsletter-embed/c.html" className="h-[100px]" height={150} width={330} title="Sealskin Newsletter" />
            {contact && (
                <div className="relative lg:mb-2.5 text-sm font-bold lg:w-auto py-7 lg:py-0 z-10 w-full flex flex-wrap gap-y-1 mt-6">
                    <ContactInfo data={contact} />
                </div>
            )}
        </div>
    </div>
);

export default Newsletter;
